import { createSelector } from 'reselect'
import { Experiments } from 'constants/experiments'
import {
  isInternationalCheckoutFlowEligibleRegion,
  isInternationalCheckoutFlowEligibleUser,
  isInternationalCheckoutFlowTreatmentVariation,
} from 'lib/checkout/internationalCheckoutFlow'
import { isBedbankItem, isLEHotelItem, isVillaItem } from 'lib/checkout/checkoutUtils'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { getAccommodationItems } from './view/accommodation'

export const isInternationalCheckoutFlowHotelCheckout = createSelector(
  (state: App.State) => getAccommodationItems(state),
  (accommodationItems): boolean =>
    accommodationItems.length > 0 &&
    accommodationItems.every(item => isLEHotelItem(item) || isBedbankItem(item) || isVillaItem(item)),
)

export const getInternationalCheckoutFlowVariationKey = (state: App.State): string | undefined =>
  state.optimizely.optimizelyExperiments[Experiments.internationalCheckoutFlow.id]?.variationKey || undefined

export const getIsInternationalCheckoutFlowEligibleCheckout = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => isInternationalCheckoutFlowHotelCheckout(state),
  (state: App.State) => getCanRedeemLuxPlusBenefits(state),
  (state: App.State) => state.auth.account.numberOfPurchases,
  (currentRegionCode, isHotelCheckout, canRedeemLuxPlusBenefits, numberOfPurchases): boolean =>
    isInternationalCheckoutFlowEligibleRegion(currentRegionCode) &&
    isHotelCheckout &&
    isInternationalCheckoutFlowEligibleUser({ canRedeemLuxPlusBenefits, numberOfPurchases }),
)

export const getIsInternationalCheckoutFlowTreatment = createSelector(
  (state: App.State) => getInternationalCheckoutFlowVariationKey(state),
  (state: App.State) => getIsInternationalCheckoutFlowEligibleCheckout(state),
  (variation, isEligibleCheckout): boolean =>
    isInternationalCheckoutFlowTreatmentVariation(variation) &&
    isEligibleCheckout,
)
